export default [
    {path: ':crop_id/:report_id'},
    {path: ':crop_id/:report_id/:trial_station_id/:year/:season_id'},
]